import React from 'react';
//import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { connect } from '../../utils';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(props.id, props.children.length, monitor.getItem());
    }
  }
};
 

const EditLayout = ({ id, children, isOverCurrent, connectDropTarget, type, layoutState, readOnly }) => {
  const {values} = layoutState.getItemJS(id).props;
  return connectDropTarget(
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: values.buttonAlign,
      flex:1,
      padding: values.containerPadding
    }}>
      <FloatingActionButton
        disabled={values.disabled}
        disabledColor={values.buttonColors.disabledColor}
        mini={values.mini}
        zDepth={values.zDepth}
        backgroundColor={values.buttonColors.backgroundColor}
      >
        <FontIcon className="material-icons" style={{fill:values.buttonColors.color, color: values.buttonColors.color}}  color={values.buttonColors.color} hoverColor={values.buttonColors.hoverColor}> {values.icon} </FontIcon>
      </FloatingActionButton>
    </div>
  );
};

 
/**
 * note : in here for edit not show the target url for button
 * href={values.href.url}
   target={values.href.target}
 */
const LayoutContainer = DropTarget('FAButtonView', target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({shallow: true})
}))(EditLayout);

export default connect('layoutState', 'readOnly')(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDFAButton.js